module.exports = __webpack_public_path__ + "img/laser_beam.4632454e.gif";